<template>
  <div class="tooltip" :style="{ left: xCoords + 'px', top: yCoords + 'px' }">
    <div class="wrapper" v-if="type === 'verschil'">
      <p class="popupTitle">{{ $t("result.z_score_verschil") }}</p>
      <p class="popupText">{{ $t("result.z_score_info") }}</p>
    </div>
    <div class="wrapper" v-if="type === 'normaal'">
      <p class="popupTitle">{{ $t("result.z_score") }}</p>
      <p class="popupText">{{ $t("result.z_score_info") }}</p>
    </div>
    <div class="wrapper" v-if="type === 'absoluut'">
      <p class="popupTitle">{{ $t("result.absoluut") }}</p>
      <p class="popupText">{{ $t("result.absoluut_info") }}</p>
    </div>
    <div class="wrapper" v-if="type === 'index'">
      <p class="popupTitle">{{ $t("result.index") }}</p>
      <p class="popupText">{{ $t("result.index_info") }}</p>
    </div>
  </div>
</template>

<script>
// export default {
//   props: {
//     type: String,
//   },
//   data() {
//     return {
//       xCoords: 0,
//       yCoords: 0,
//     };
//   },
//   mounted() {
//     document.addEventListener("mousemove", this.followMouse);
//   },
//   beforeDestroy() {
//     document.removeEventListener("mousemove", this.followMouse);
//   },
//   methods: {
//     followMouse(e) {
//       this.xCoords = e.pageX;
//       this.yCoords = e.pageY;
//     },
//   },
// };

import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  name: "YourComponentName",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup() {
    const xCoords = ref(0);
    const yCoords = ref(0);

    const followMouse = (e) => {
      xCoords.value = e.pageX;
      yCoords.value = e.pageY;
    };

    onMounted(() => {
      document.addEventListener("mousemove", followMouse);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("mousemove", followMouse);
    });

    // Return reactive variables and methods so they can be used in the template
    return {
      xCoords,
      yCoords,
      followMouse,
    };
  },
};
</script>

<style lang="sass" scoped>
.tooltip
  position: absolute
  display: flex
  text-align: left
  width: 407px
  margin-top: 20px
  margin-left: 15px
  padding: 20px
  box-sizing: border-box
  border-radius: 10px
  box-shadow: 0 2px 7px 0 rgba($black,0.3)
  background-color: $white
  z-index: 10008
  .wrapper
    display: flex
    flex-direction: column
    color: $black
    .popupTitle
      display: flex
      justify-content: center
      margin: 0
      font-size: 24px
      line-height: 34px
      font-weight: bold
    .popupText
      margin: 0
      font-size: 15px
      line-height: 22px
</style>
